import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";

import {
  normalizeTwoWords,
  formatImageAlt,
  findRel,
} from "../../../shared/utils/stringUtilities";
import NavMenu from "../../molecules/nav-menu/navMenu";
// import RecommenderModal from "../recommender-modal/recommenderModal";

import "./nav.scss";

interface NavInterface {
  isMenuActive: boolean;
  isSearcherActive: boolean;
  isDark: boolean;
  actionTheme: () => void;
  setSearcherActive: () => void;
  setMenuActive: (isMenuActive: boolean) => void;
}

const Nav = ({
  isMenuActive,
  isSearcherActive,
  isDark,
  setSearcherActive,
  setMenuActive,
  actionTheme,
}: NavInterface) => {
  const [isRecommenderOpen, setIsRecommenderOpen] = useState(false);

  return (
    <div className="o-nav">
      {/*<RecommenderModal
        open={isRecommenderOpen}
        onClose={() => setIsRecommenderOpen(false)}
  />*/}

      <NavMenu
        setSearcherActive={setSearcherActive}
        setMenuActive={setMenuActive}
        isMenuActive={isMenuActive}
        isSearcherActive={isSearcherActive}
        sideLinks={[]}
        isDark={isDark}
        actionTheme={actionTheme}
      />
    </div>
  );
};

export default Nav;
